// @flow

import accountChild from 'app/get-help/content/nodes/loggedIn/account';
import createZapChild from 'app/get-help/content/nodes/loggedIn/zaps';
import createZapierChild from 'app/get-help/content/nodes/loggedIn/zapier';
import help from 'app/get-help/components/blocks/Help';
import topic from 'app/get-help/components/blocks/Topic';
import zapTroubleshootingChild from 'app/get-help/content/nodes/loggedIn/zapTroubleshooting';
import zap from 'app/get-help/components/blocks/Zap';
import { getDefaultFields } from 'app/get-help/content/nodes/common';
import { ZENDESK_CUSTOM_FIELD_IDS } from 'app/get-help/constants';


const loggedIn = topic({
  label: 'What would you like more help with?',
  zendeskCustomFieldId: ZENDESK_CUSTOM_FIELD_IDS.MORE_INFORMATION_REQUEST,
  items: [
    {
      value: 'troubleshooting',
      icon: 'alertCircle',
      label: 'Zap troubleshooting',
      zendeskCustomFieldValue: 'cf-zap-troubleshooting',
      child: zapTroubleshootingChild,
    },
    {
      value: 'zaps',
      icon: 'miscBoltAlt',
      label: 'Creating and managing Zaps',
      zendeskCustomFieldValue: 'cf-creating-managing',
      child: zap({
        title: 'Which Zap do you have a question about?',
        instructions:
          'By selecting a Zap, we‘ll be able to get back to you with a better and faster response.',
        kind: ['workflow'],
        kindDisplayName: 'Zap',
        child: createZapChild(true),
      }),
    },
    {
      value: 'account',
      icon: 'personCircle',
      label: 'Accounts, pricing, and billing',
      zendeskCustomFieldValue: 'cf-accounts-billing',
      child: accountChild,
    },
    {
      value: 'zapier',
      icon: 'alertInfo',
      label: 'About Zapier',
      zendeskCustomFieldValue: 'cf-about-zapier',
      child: createZapierChild(true),
    },
    {
      value: 'other',
      icon: 'navHelp',
      label: 'Something else',
      zendeskCustomFieldValue: 'cf-something-else',
      child: help({ contact: getDefaultFields(true) }),
    },
  ],
});

export default loggedIn;
